import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ApiConfigService } from '../../../infrastructure/api-config.service';

@Component({
  selector: 'app-debug-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule],
  templateUrl: './debug-modal.component.html',
  styleUrl: './debug-modal.component.scss',
})
export class DebugModalComponent implements OnChanges {
  private readonly apiConfigService = inject(ApiConfigService);

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  protected customEndpoint = '';

  get currentEndpoint(): string {
    return this.apiConfigService.apiUrl;
  }

  get isCustomEndpoint(): boolean {
    return this.apiConfigService.isCustomEndpoint;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.customEndpoint = '';
    }
  }

  setEndpoint(): void {
    if (this.customEndpoint.trim()) {
      this.apiConfigService.setCustomEndpoint(this.customEndpoint);
      this.customEndpoint = '';
    }
  }

  resetEndpoint(): void {
    this.apiConfigService.resetToDefault();
  }

  close(): void {
    this.visibleChange.emit(false);
  }

  confirm(): void {
    this.close();
    window.location.reload();
  }

  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('debug-modal-overlay')) {
      this.close();
    }
  }
}
